import { useState as l } from "react";
import { disposables as m } from '../utils/disposables.js';
import { useIsoMorphicEffect as p } from './use-iso-morphic-effect.js';
function h(i) {
  if (i === null) return {
    width: 0,
    height: 0
  };
  let {
    width: t,
    height: e
  } = i.getBoundingClientRect();
  return {
    width: t,
    height: e
  };
}
function w(i, t) {
  let e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  let [r, f] = l(() => h(t));
  return p(() => {
    if (!t || !i) return;
    let n = m();
    return n.requestAnimationFrame(function s() {
      n.requestAnimationFrame(s), f(u => {
        let o = h(t);
        return o.width === u.width && o.height === u.height ? u : o;
      });
    }), () => {
      n.dispose();
    };
  }, [t, i]), e ? {
    width: "".concat(r.width, "px"),
    height: "".concat(r.height, "px")
  } : r;
}
export { w as useElementSize };